import { PropsWithChildren, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Union } from 'ts-toolbelt';

import { ThreadVariant } from '../../Cockpit.types.ts';
import { RouteId } from '~/routes/RouteId.ts';

import { CockpitContextProviderContext } from './CockpitContextProvider.context.ts';
import { variantRouteMapping } from './CockpitContextProvider.utils.ts';

export const CockpitContextProvider = ({ children }: PropsWithChildren) => {
  const { id } = useParams();
  const [threadId, setThreadId] = useState<Union.Nullable<string>>(id);
  const [initialMessage, setInitialMessage] = useState<Union.Nullable<string>>(null);
  const navigate = useNavigate();

  const clearInitialMessage = () => {
    setInitialMessage(null);
  };

  const value = {
    threadId,
    initialMessage,
    openThread: (id: string, variant: ThreadVariant, initialMessage?: string) => {
      setThreadId(id);
      setInitialMessage(initialMessage);
      navigate(variantRouteMapping[variant](id));
    },
    closeThread: () => {
      setThreadId(null);
      clearInitialMessage();
      navigate(RouteId.cockpit);
    },
    clearInitialMessage,
  };

  return <CockpitContextProviderContext.Provider value={value}>{children}</CockpitContextProviderContext.Provider>;
};
